import React from 'react';
import { Form, Select } from 'antd';
import { CURRENCIES, ECurrency } from 'types/currencies';

export const FormCurrencySelect: React.FC = () => {
  return (
    <Form.Item name='currency' noStyle>
      <Select defaultValue={ECurrency.EUR}>
        {CURRENCIES.map((currency) => (
          <Select.Option key={currency.value} value={currency.value}>
            {currency.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
